import React from "react";
import PropTypes from "prop-types";
import { POPUP_SECTIONS } from "../../../constant/constant";
import { isSectionVisible } from "../../../../shared/section-visibility.js";
import TextBlock from "../../../components/Preview/Draggable/Block/TextBlock";
import ExtensionPreviewSlot from "../ExtensionPreviewSlot";
import { ExtensionCompactLayout } from "../../../components/Preview/catalog-product";
import AiBrandAttribution from "../../ai-recommendation-upsell/components/AiBrandAttribution";
import widgetStyles from "./extension-upsell-widget.module.css";

export default function ExtensionUpsellWidget({
  surfaceBadge,
  mapped,
  popupData,
  activeStep,
  currentParentData,
  selectedBlock,
  handleBlockClick,
  isSelected,
  renderCta,
  variant = "default",
}) {
  const isCartDrawer = variant === "cart-drawer";
  const shellClass = isCartDrawer
    ? widgetStyles.cartDrawerShell
    : widgetStyles.widgetShell;

  const headlineBlock =
    mapped.headline && isSectionVisible(mapped.headline.section) ? (
      <ExtensionPreviewSlot
        isSelected={isSelected(mapped.headline)}
        onClick={() => handleBlockClick(mapped.headline)}
        className={isCartDrawer ? widgetStyles.cartDrawerHeadline : undefined}
      >
        <TextBlock
          section={mapped.headline.section}
          parentData={currentParentData}
        />
      </ExtensionPreviewSlot>
    ) : null;

  return (
    <>
      {!isCartDrawer ? headlineBlock : null}

      {mapped.product && isSectionVisible(mapped.product.section) ? (
        <div className={shellClass}>
          {!isCartDrawer && surfaceBadge ? (
            <span className={widgetStyles.widgetBadge}>{surfaceBadge}</span>
          ) : null}
          {isCartDrawer ? headlineBlock : null}
          <ExtensionPreviewSlot
            isSelected={
              selectedBlock.type === POPUP_SECTIONS.PRODUCT &&
              selectedBlock.index === mapped.product.index &&
              selectedBlock.parentIndex == null
            }
            onClick={() => handleBlockClick(mapped.product)}
          >
            <ExtensionCompactLayout
              popupData={popupData}
              section={mapped.product.section}
              activeStep={activeStep}
              parentIndex={mapped.product.index}
              footerContent={renderCta(mapped.primaryCta, true)}
              extensionVariant={isCartDrawer ? "cart-drawer" : "default"}
            />
          </ExtensionPreviewSlot>
          {mapped.brandAttribution &&
          isSectionVisible(mapped.brandAttribution.section) ? (
            <div
              className={`${widgetStyles.branding} ${
                isCartDrawer ? widgetStyles.cartDrawerBranding : ""
              }`.trim()}
            >
              <ExtensionPreviewSlot
                isSelected={isSelected(mapped.brandAttribution)}
                onClick={() => handleBlockClick(mapped.brandAttribution)}
              >
                <AiBrandAttribution section={mapped.brandAttribution.section} />
              </ExtensionPreviewSlot>
            </div>
          ) : null}
        </div>
      ) : null}
    </>
  );
}

ExtensionUpsellWidget.propTypes = {
  surfaceBadge: PropTypes.string,
  mapped: PropTypes.object.isRequired,
  popupData: PropTypes.object,
  activeStep: PropTypes.number,
  currentParentData: PropTypes.object,
  selectedBlock: PropTypes.object,
  handleBlockClick: PropTypes.func.isRequired,
  isSelected: PropTypes.func.isRequired,
  renderCta: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(["default", "cart-drawer"]),
};
